import { validateNotEmptyString } from '@vy/utils';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useQuickBooksConnect() {
  return useMutation(async () => {
    const api = getPrivateApi();

    const { redirectUrl } = await api.quickbooksConnect();

    validateNotEmptyString(redirectUrl, 'redirectUrl');

    window.location.href = redirectUrl;
  });
}
